import { SETTLEMENT_ADVANCE } from '@services/permissions'

import type { Section } from '../types'

export const settlementAdvanceHistorySection: Section = {
  label: 'layout:page.settlementAdvance.history',
  route: '/settlement-advance/history',
  permissions: SETTLEMENT_ADVANCE,
  segment: {
    page: 'Settlement Advance - History',
  },
}

export const settlementAdvanceRequestSection: Section = {
  label: 'layout:page.settlementAdvance.request',
  route: '/settlement-advance/request',
  permissions: SETTLEMENT_ADVANCE,
  segment: {
    page: 'Settlement Advance - Request',
  },
}

export const settlementAdvanceDetailSection: Section = {
  label: 'layout:page.settlementAdvance.detail',
  route: '/settlement-advance/history/[id]',
  permissions: SETTLEMENT_ADVANCE,
  segment: {
    page: 'Settlement Advance - Detail Page',
  },
}

export const settlementAdvanceSection: Section = {
  icon: 'ClockNavOutline',
  label: 'layout:page.settlementAdvance.title',
  route: '/settlement-advance/request',
  permissions: SETTLEMENT_ADVANCE,
  pages: [
    settlementAdvanceRequestSection,
    settlementAdvanceHistorySection,
    settlementAdvanceDetailSection,
  ],
  segment: {
    page: 'Settlement Advance - Request',
  },
}
